import axios from "axios";
// import { toast } from "react-toastify";

import config from "../config/config";
import { toast } from "react-toastify";
axios.defaults.withCredentials = true;

const http = {
  get: async (url) => {
    try {
      const response = await axios.get(url);

      const { data } = response;

      if (data.status === 200) {
        return data;
      }

      if (data.status >= 400 || data.status <= 499) {
        toast.error(data.message);

        return null;
      }
    } catch (error) {
      // notification["error"]({
      //   message: "Internal Server Error",
      // });

      toast.error("Internal Server Error");
      console.log("error", error.response);
      //   return false;
    }
  },
  post: async (url, request, options = {}) => {
    const { showErrorToast = true } = options;

    try {
      const response = await axios.post(url, request);

      const { data } = response;
      if (data.status === 200) {
        return data;
      }

      if (data.status >= 400 && data.status <= 499) {
        if (showErrorToast) {
          toast.error(data.message);

          return null;
        }

        return data;
      }

      return data;
    } catch (error) {
      console.log("HTTP error:", error);

      // Browser/network is offline or request could not reach server
      if (!error.response) {
        const networkError = {
          status: 0,
          message: "Something went wrong. Please check your internet connection and try again.",
        };

        if (showErrorToast) {
          toast.error(networkError.message);
        }

        return networkError;
      }

      // Backend returned an error response
      if (!showErrorToast) {
        return error.response.data || {
          status: error.response.status || 500,
          message: "Something went wrong. Please try again.",
        };
      }

      toast.error(
        error.response.data?.message || "Internal Server Error"
      );

      return null;
    }
  },

  put: async (url, request) => {
    try {
      const response = await axios.put(url, request);

      const { data } = response;

      if (data.status === 200) {
        return data;
      }

      if (data.status >= 400 || data.status <= 499) {
        toast.error(data.message);

        return null;
      }
    } catch (error) {
      toast.error("Internal Server Error");

      console.log("error", error.response);
      //   return false;
    }
  },
  delete: async (url) => {
    try {
      const response = await axios.delete(url);

      const { data } = response;

      if (data.status === 200) {
        return data;
      }

      if (data.status >= 400 || data.status <= 499) {
        toast.error(data.message);

        return null;
      }
    } catch (error) {
      toast.error("Internal Server Error");

      console.log("error", error.response);
      //   return false;
    }
  },
};
export default http;
